import { injectable } from "inversify";
import { ApiPage } from "@/core/models/page.model";
import { TableRepo } from "../table.repo";
import { AppRoleModel } from "@/core/models/app-role.model";

interface _AppRoleGetParams {
    search?: string;
}

@injectable()
export class AppRoleRepo extends TableRepo<AppRoleModel> {
    constructor() {
        super("/api/AppRole");
    }

    async getData(index: number, params: _AppRoleGetParams, pageSize = 10): Promise<ApiPage<AppRoleModel>|null> {
        return await super.getData(index, params, pageSize);
    }

    async updateClaims(role: AppRoleModel, permissionKeys: string[]) {
        try {
            const response = await this.apiRepo.post(`${this.basepath}/update-claim`, {role, permissionKeys});
            if (response?.code === '00') {
                this.changes.next(Date.now());
                return true
            };
            return false;
        } catch (err) {
            console.log(err);
        }
    }

    async getAllClaims(roleName: string) {
        const response = await this.apiRepo.get<AppRoleModel[]>(`${this.basepath}/get-all-claims`, {roleName});
        if (response?.code === "00") {
            return response.result;
        }
        return [];
    }

    async getClaimTemplates() {
        const response = await this.apiRepo.get<Array<{id: string, group: string, checked: boolean, name: string}>>(`${this.basepath}/get-claim-templates`);
        if (response?.code === "00") {
            return response.result || [];
        }
        return [];
    }
}